import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { AppProvider } from './context/AppContext';
import { Toaster } from 'react-hot-toast';
import { registerServiceWorker } from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
registerServiceWorker();

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppProvider>
        <App />
        <Toaster 
          position="top-center"
          toastOptions={{
            duration: 3000,
            style: { background: '#333', color: '#fff' }
          }}
        />
      </AppProvider>
    </AuthProvider>
  </React.StrictMode>
);